import { Alert } from 'antd';
import { useConfigFormContext } from './ConfigFormContext';

export default function CredentialSecurityNotice() {
    const { isEditMode } = useConfigFormContext();

    if (!isEditMode) {
        return null;
    }

    return (
        <Alert
            message="Security Notice"
            description="For security reasons, existing credentials are not displayed. Leave credential fields (passwords, access keys, tokens) empty to keep the current credentials, or fill them in to update."
            type="info"
            showIcon
            className="!mb-4"
        />
    );
}
